import { HttpErrorResponse } from '@angular/common/http';
import { Component, Inject } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

interface InputData {
	placeholder?: string;
	label?: string;
	hint?: string;
}

export interface MultiTextInputOptions {
	headline?: string;
	description?: string;

	input?: InputData;
	callback?: (values: string[]) => Promise<string | undefined>;
}

@Component({
	selector: 'app-multi-text-input-dialog',
	standalone: false,
	templateUrl: './multi-text-input-dialog.component.html',
	styleUrl: './multi-text-input-dialog.component.scss',
})
export class MultiTextInputDialogComponent {
	protected headline: string;
	protected isUpdating: boolean = false;
	protected description?: string;
	protected error?: string;
	protected inputData?: InputData;

	protected values: string[] = [];

	private callback?: (values: string[]) => Promise<string | undefined>;

	constructor(
		private fb: FormBuilder,
		private dialogRef: MatDialogRef<MultiTextInputDialogComponent>,
		@Inject(MAT_DIALOG_DATA) public data: MultiTextInputOptions
	) {
		this.headline = data.headline || 'Enter one or more values';
		this.description = data.description;
		this.inputData = data.input;
		this.callback = data.callback;
	}

	public close(value: any) {
		this.dialogRef.close(value);
	}

	public addValue(tenant: string) {
		this.values.push(tenant);
	}

	public deleteValue(index: number) {
		this.values.splice(index, 1);
		this.values = [...this.values];
	}

	public async update() {
		this.isUpdating = true;
		let result: any = undefined;

		let value = this.values;
		if (value === null) {
			value = [];
		}

		if (this.callback) {
			try {
				result = await this.callback(value);
			} catch (err) {
				if (err instanceof Error) {
					result = err.message;
				} else if (err instanceof HttpErrorResponse) {
					result = err.error.message;
				} else {
					result = err;
				}
			}
		}

		if (result === undefined) {
			this.close(value);
		} else {
			this.error = result;
		}

		this.isUpdating = false;
	}
}
